import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

const KEY = "vt-fav-communes";
const EVT = "vt-fav-communes";
export const FAV_MAX = 3;

const read = () => { try { return JSON.parse(localStorage.getItem(KEY) || "[]"); } catch { return []; } };
const writeLocal = (list) => { localStorage.setItem(KEY, JSON.stringify(list)); window.dispatchEvent(new Event(EVT)); };
const merge = (a, b) => [...a, ...b.filter((x) => !a.some((y) => y.commune === x.commune))].slice(0, FAV_MAX);
const synced = new Set();

// Comunas favoritas (hasta 3): en la cuenta si hay sesión iniciada, si no en este navegador.
export function useFavCommunes() {
  const { user } = useAuth();
  const uid = user?.id || user?._id || user?.email;
  const [favs, setFavs] = useState(read);

  useEffect(() => {
    const sync = () => setFavs(read());
    window.addEventListener(EVT, sync);
    window.addEventListener("storage", sync);
    return () => { window.removeEventListener(EVT, sync); window.removeEventListener("storage", sync); };
  }, []);

  useEffect(() => {
    if (!uid || synced.has(uid)) return;
    synced.add(uid);
    api.get("/geo/favorites").then(async ({ data }) => {
      const local = read();
      const all = merge(data, local);
      if (all.length !== data.length) await api.put("/geo/favorites", { favorites: all }).catch(() => {});
      writeLocal(all);
    }).catch(() => synced.delete(uid));
  }, [uid]);

  const save = (list) => {
    writeLocal(list);
    if (uid) api.put("/geo/favorites", { favorites: list }).catch(() => toast.error("No pudimos guardar tus favoritas en tu cuenta"));
  };
  const isFav = (c) => favs.some((f) => f.commune === c);
  const toggle = (region, commune) => {
    if (isFav(commune)) { save(favs.filter((f) => f.commune !== commune)); return; }
    if (favs.length >= FAV_MAX) { toast.info(`Puedes guardar hasta ${FAV_MAX} comunas favoritas. Quita una para agregar ${commune}.`); return; }
    save([...favs, { region, commune }]);
    toast.success(uid ? `${commune} guardada en tus favoritas de tu cuenta` : `${commune} guardada en tus favoritas`);
  };
  return { favs, isFav, toggle };
}
